module.exports = __webpack_public_path__ + "img/delete.6d954c2f.svg";